<div layout layout-space-between>
  <div layout-vertical>
    <rt-heading variant="heading">
      {{
        questionTitle() ??
          ('app.interview.summary.skills_summary.evaluations_per_skill' | translate)
      }}
    </rt-heading>
    <span class="description">
      {{ 'app.evaluation_tab.form_details.answers_count' | translate: { count: answersCount() } }}
      @if (commentsCount()) {
        ·
        {{
          'app.evaluation_tab.form_details.comments_count' | translate: { count: commentsCount() }
        }}
      }
    </span>
  </div>

  @if (showPositionButton()) {
    <div layout margin-left-small-x>
      <rt-button variant="plain" size="small" (click)="viewPosition.emit()">
        {{ 'app.interview.summary.skills_summary.view_position' | translate }}
      </rt-button>
    </div>
  }
</div>

@if (answersCount() === 0) {
  <rt-empty-state
    icon="thumbs-up-down"
    [title]="'app.evaluation_tab.form_details.no_answers.title' | translate"
    [desc]="'app.evaluation_tab.form_details.no_answers.description' | translate"
    margin-top-small
  />
} @else {
  <div class="summary" layout layout-align-items-center margin-top-small>
    @if (theme(); as theme) {
      <rt-candidate-skills-chart
        [skills]="summary()"
        [size]="150"
        [theme]="theme"
        [thickness]="15"
        [labelFontSize]="12"
      />
    }

    <div
      [class.four-columns]="statusColumns().length === 4"
      [class.three-columns]="statusColumns().length === 3"
      class="statuses-container"
      layout
      layout-align-items-center
      min-width-0
    >
      <div class="statuses-wrapper" padding-left min-width-0>
        @for (column of statusColumns(); track column.status; let last = $last) {
          <div class="status-column" layout>
            <div layout layout-flex-1>
              <div layout margin-right-small-x margin-top-small-xx>
                <span class="skill-leaf" [class]="column.status"></span>
              </div>
              <div layout-vertical min-width-0>
                <div layout layout-align-items-start margin-bottom-small-xxx>
                  <span text-large text-darkest text-bold margin-right-small-xx>{{
                    column.skills.length
                  }}</span>
                  <span>{{ column.label }}</span>
                </div>
                <div layout layout-wrap>
                  @for (skill of column.skills; track skill.id) {
                    <rt-badge
                      [color]="'counter-light'"
                      [contentTpl]="badgeContent"
                      [rtTooltip]="skill.name"
                      [rtTooltipEnableWhenTruncated]="true"
                      class="transform-none badge"
                      margin-right-small-xx
                      margin-bottom-small-xx
                    />
                    <ng-template #badgeContent>
                      <span>{{ skill.name }}</span>
                    </ng-template>
                  }
                  @if (!column.skills.length) {
                    <span>-</span>
                  }
                </div>
              </div>
            </div>
            @if (!last) {
              <div layout margin-lr padding-tb-small-x>
                <div class="custom-divider"></div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  @let noRequiredLevelSkillsCount = summary().noRequiredLevelSkills.length;
  @if (noRequiredLevelSkillsCount) {
    <rt-infobox
      [type]="'transparent'"
      [iconName]="'info-outline'"
      [isDismissible]="false"
      [messagePaddingSmall]="true"
      margin-top
    >
      <div layout>
        <span
          [innerHTML]="
            (noRequiredLevelSkillsCount === 1
              ? 'app.interview.summary.skills_summary.no_required_level_infobox.content_one'
              : 'app.interview.summary.skills_summary.no_required_level_infobox.content_other'
            ) | translate: { count: noRequiredLevelSkillsCount }
          "
        ></span>
      </div>
    </rt-infobox>
  }

  <div
    (click)="toggleCollapsed()"
    class="evaluations-toggle"
    layout
    layout-align-items-center
    margin-top-small
  >
    <span text-bold>
      {{ 'app.interview.summary.skills_summary.evaluations_per_skill' | translate }}
    </span>
    <rt-icon
      size="small"
      [name]="isCollapsed() ? 'expand-more' : 'expand-less'"
      margin-left-small-xx
    />
  </div>

  @if (!isCollapsed()) {
    <div class="columns-container" margin-top-small margin-bottom-small-x>
      <div class="columns">
        <div>{{ 'app.interview.summary.skills_summary.columns.skill' | translate }}</div>
        <div>
          {{ 'app.interview.summary.skills_summary.columns.proficiency_level' | translate }}
        </div>
        <div>
          {{ 'app.interview.summary.skills_summary.columns.evaluation_details' | translate }}
        </div>
      </div>
    </div>

    <div layout-vertical>
      @for (skill of skills(); track skill.id) {
        <rt-evaluation-skill [skill]="skill" />
      }
    </div>
  }
}
